import React, { useState, useEffect, useCallback } from 'react';
import {
  IconButton,
  Grid,
  Box,
  Typography,
  Divider,
  Button,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import Alert from '@material-ui/lab/Alert';
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn';

// components
import { useHistory, useParams } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import Notification from '../../utils/notification';
import Widget from '../../components/Widget/Widget';

import { useLayoutDispatch, toggleLoading } from '../../context/LayoutContext';
import { useUserState } from '../../context/UserContext';
import useStyles from './styles';
import api from '../../services/api';
import {
  moneyToMask, toCurrency, maskToMoney
} from '../../utils/mask';
import { VALOR_MIN, VALOR_MAX } from '../../utils/constants';
import { getError } from '../../utils/getResponseError';

export default function CadastroProduto() {
  const history = useHistory();
  const classes = useStyles();
  const layoutDispatch = useLayoutDispatch();
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [error, setError] = useState();
  const [data, setData] = useState({
    nome: '',
    valor: '',
    descricao: '',
  });

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      getProduto(id);
    }
  }, [id]);

  async function getProduto(id) {
    toggleLoading(layoutDispatch);
    try {
      const { data: result } = await api.get(`/produto/${id}`);
      setData({
        ...result,
        valor: toCurrency(result.valor)
      });
      toggleLoading(layoutDispatch);
    } catch (error) {
      toggleLoading(layoutDispatch);
      Notification({
        type: 'report',
        message: getError(error),
        variant: 'contained',
        color: 'secondary',
      });
      history.push('/app/produtos');
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setIsSubmiting(true);
    try {
      const valorNumerico = maskToMoney(data.valor);
      if (valorNumerico < VALOR_MIN || valorNumerico > VALOR_MAX) {
        setIsSubmiting(false);
        return setError(`O valor deve estar entre R$ ${VALOR_MIN.toFixed(2).replace('.', ',')} e R$ ${VALOR_MAX.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`);
      }
      const obj = {
        nome: data.nome,
        descricao: data.descricao !== '' ? data.descricao : null,
        valor: valorNumerico
      };
      if (id) {
        await api.put(`produto/${id}`, obj);
        Notification({
          type: 'shipped',
          message: 'Produto atualizado',
          variant: 'contained',
          color: 'success',
        });
      } else {
        await api.post('produto', obj);
        Notification({
          type: 'shipped',
          message: 'Produto cadastrado',
          variant: 'contained',
          color: 'success',
        });
      }

      history.push('/app/produtos');
    } catch (error) {
      setError(getError(error));
    }
    setIsSubmiting(false);
  }

  function handleChange(e) {
    const { name, value: oldValue } = e.target;
    let value = oldValue;

    if (name === 'valor') {
      value = moneyToMask(value);
    }

    setData((old) => ({ ...old, [name]: value }));
  }

  return (
    <>
      <PageTitle
        title="Cadastro de produtos"
        button={(
          <IconButton
            color="primary"
            aria-label="cadastrar novo cliente"
            className={classes.addButton}
            onClick={() => history.push('/app/produtos')}
          >
            <KeyboardReturnIcon />
          </IconButton>
        )}
      />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget disableWidgetMenu>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Grid container item xs={12}>
                <Grid item sm={12} xs={12}>
                  <Box px={3} pt={0} pb={0}>
                    <Typography variant="h5" color="textSecondary" noWrap>
                      Dados cadastrais
                    </Typography>
                    <Divider className={classes.divider} />
                  </Box>
                </Grid>
                <Grid item sm={8} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required
                      label="Nome do produto"
                      fullWidth
                      value={data.nome}
                      name="nome"
                    />
                  </Box>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required
                      label="Valor"
                      fullWidth
                      value={data.valor}
                      name="valor"
                      inputProps={{
                        maxLength: 18,
                        min: VALOR_MIN,
                        max: VALOR_MAX
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item sm={12} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      label="Descrição"
                      fullWidth
                      value={data.descricao}
                      name="descricao"
                    />
                  </Box>
                </Grid>

              </Grid>
              <Grid container item xs={12}>
                <Grid item xs={12} sm={8}>
                  <Box px={3} py={2} color="red">
                    {error && (
                      <Alert severity="error">{error}</Alert>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box px={3} py={2} className={classes.botaoDireta}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={isSubmiting}
                    >
                      {isSubmiting ? <CircularProgress size={25} /> : 'Salvar'}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </Widget>
        </Grid>
      </Grid>
    </>
  );
}
